import React from "react";

const Section = ({ title, children }) => (
  <div className="w-[49%] py-2 pr-3">
    <h3 className="font-bold text-lg p-2 font-poppin">{title}</h3>
    {children}
  </div>
);

export default Section;
